import fundingRequests from './models/FundingRequests';

export default { fundingRequests };
